export const LayoutContentSearch = (state) => {
  return state.LayoutContent.search
}

export const LayoutContentMenus = (state) => {
  return state.LayoutContent.menus
}

export const LayoutContentBreadCrumbKeys = (state) => {
  return state.LayoutContent.BreadCrumbKeys
}
